import { getMachinePort } from './definitions.js'

const makeRoute = (_points) =>
{
    const segments = []
    let length = 0
    for(let index = 0; index < _points.length - 1; index++)
    {
        const from = _points[index]
        const to = _points[index + 1]
        const segmentLength = Math.hypot(to.x - from.x, to.y - from.y)
        if(segmentLength < 0.0001)
            continue
        segments.push({ from, to, length: segmentLength, start: length })
        length += segmentLength
    }
    return { points: _points, segments, length }
}

export const resolveBeltRoutes = (_definition, _machines) =>
{
    const sourceMachine = _machines.find((_machine) => _machine.id === _definition.source)
    if(!sourceMachine)
        return []
    const source = getMachinePort(sourceMachine, 'output')
    return _definition.destinations.map((_destination) =>
    {
        const destinationMachine = _destination.machine ? _machines.find((_machine) => _machine.id === _destination.machine) : null
        const endpoint = destinationMachine ? getMachinePort(destinationMachine, 'input', _destination.input) : { x: _destination.x, y: _destination.y, z: 0.08 }
        const points = [source, ...(_definition.via ?? []), ...(_destination.via ?? []), endpoint]
        return { ...makeRoute(points), destination: _destination }
    })
}

export const sampleBeltRoute = (_route, _distance) =>
{
    const distance = Math.max(0, Math.min(_distance, _route.length))
    const segment = _route.segments.find((_item) => distance <= _item.start + _item.length) ?? _route.segments.at(-1)
    if(!segment)
        return { x: 0, y: 0, angle: 0 }
    const progress = (distance - segment.start) / segment.length
    return {
        x: segment.from.x + (segment.to.x - segment.from.x) * progress,
        y: segment.from.y + (segment.to.y - segment.from.y) * progress,
        angle: Math.atan2(segment.to.y - segment.from.y, segment.to.x - segment.from.x)
    }
}
